/* Moment */
import moment from "moment"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { file } from "../../api/Rsg"

/* Helpers */
import { utils } from "../../helpers"

/* Sweet alert */
import Swal from "../../helpers/alert"


/* AMOUNT OF THE REGULATOR — ALWAYS TWO DECIMALS */
export const formatAmount = (value) => {

    /* Fields */
    const number = parseFloat(value)

    /* Check Number */
    if (isNaN(number)) {
        return "0.00"
    }

    /* Send Result */
    return number.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}


/* SIGNED AMOUNT — GGR GOES BOTH WAYS */
export const formatSigned = (value) => {

    /* Fields */
    const number = parseFloat(value) || 0

    /* Send Result */
    return `${number >= 0 ? "+" : "-"}${formatAmount(Math.abs(number))}`
}


/* DATE WITH THE TIME OF THE PANEL */
export const formatDate = (value, withTime = true) => {

    /* Check Value */
    if (value === null || value === undefined || value === "") {
        return "-"
    }

    /* Send Result */
    return moment(value).format(withTime ? "DD.MM.YYYY HH:mm" : "DD.MM.YYYY")
}


/* PERIOD OF A REPORT
 * COMPLIANCE covers one day, while an OPERATION reportDate is the first day of the next month,
 * so the period ends the day before it — exactly the same window the backend aggregates. */
export const formatPeriod = (reportDate, reportType) => {

    /* Check Value */
    if (!reportDate) {
        return "-"
    }

    /* Check Type */
    if (reportType !== "OPERATION") {
        return moment(reportDate).format("DD.MM.YYYY")
    }

    /* Prepare Range */
    const start = moment(reportDate).subtract(1, "month")
    const end = moment(reportDate).subtract(1, "day")

    /* Send Result */
    return `${start.format("DD.MM.YYYY")} — ${end.format("DD.MM.YYYY")}`
}


/* DOWNLOAD THE XML FILE OF A REPORT — THE ANSWER IS A BLOB, A HIDDEN LINK SAVES IT */
export const downloadReport = (report) => {

    return file(report.id).then((response) => {

        /* Check Response */
        if (response.status !== 200) {

            /* The answer of an error is a blob too, so only the status tells what happened */
            if (response.status === 404) {
                Swal.fire(utils.notification(t("rsg.fileMissing"), "error"))
            }
            else if (response.status === 401 || response.status === 403) {
                Swal.fire(utils.notification(t("swal.noAccess"), "error"))
            }
            else if (response.status === 498) {
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }

            return
        }

        /* Save The Blob As A File */
        const url = window.URL.createObjectURL(response.data)
        const link = document.createElement("a")

        link.href = url
        link.download = report.file || report.fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

    }).catch(() => {
        Swal.fire(utils.notification(t("swal.generic"), "error"))
    })

}
